var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVideoPlayer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34,48.75a.75023.75023,0,0,0,.335-.0791l16-8a.74977.74977,0,0,0,0-1.3418l-16-8A.74955.74955,0,0,0,33.25,32V48a.74924.74924,0,0,0,.75.75Zm.75-15.53662L48.32324,40,34.75,46.78662Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10,66.75H70a.7502.7502,0,0,0,.75-.75V14a.7502.7502,0,0,0-.75-.75H10a.7502.7502,0,0,0-.75.75V66A.7502.7502,0,0,0,10,66.75Zm23.25-1.5H22.75v-6.5h10.5Zm12,0H34.75v-6.5h10.5Zm12,0H46.75v-6.5h10.5Zm12,0H58.75v-6.5h10.5Zm-10.5-50.5h10.5v6.5H58.75Zm-12,0h10.5v6.5H46.75Zm-12,0h10.5v6.5H34.75Zm-12,0h10.5v6.5H22.75Zm-12,0h10.5v6.5H10.75Zm0,8h58.5v34.5H10.75Zm0,36h10.5v6.5H10.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoPlayer);
export default __webpack_public_path__ + "static/media/icon_video_player.5fce01a1b278de69f5bb9be72688c6ab.svg";
export { ForwardRef as ReactComponent };